export const initialFilter = {
  filter: {
    name: "",
  },
  pluginStatus:"",
  search: "",
  sortOrder: "desc", // asc||desc
  sortField: "date",
  pageNumber: 1,
  pageSize: 10,
};
